export const typeIconMap: { [key in server.dto.AppointmentTypes]: string } = {
  accommodation: "icon-accommodation",
  show: "icon-show",
  train: "icon-train",
  flight: "icon-flight",
  externalCalendar: "icon-external",
  groundTransport: "icon-groundtransport",
  unknown: ""
};

export const phaseIconMap: { [key in server.dto.AppointmentPhases]: string } = {
  cancelled: "icon-cancelled",
  confirmed: "icon-confirmed",
  option: "icon-option",
  unknown: ""
};

export const getId = (appointment: server.dto.PlannerAppointment): string => {
  if (appointment.showId) { return appointment.showId.toString(); }
  if (appointment.trainSegmentId) { return appointment.trainSegmentId.toString(); }
  if (appointment.flightSegmentId) { return appointment.flightSegmentId.toString(); }
  if (appointment.groundTransportId) { return appointment.groundTransportId.toString(); }
  if (appointment.externalEventId) { return appointment.externalEventId.toString(); }

  throw new Error(`Unknown appointment type: ${JSON.stringify(appointment)}`);
};

export const canLinkAppointment = (canLinkUnlinkTravel: boolean, showId: number, appointment: server.dto.PlannerAppointment): boolean => {
  if (!canLinkUnlinkTravel) {
    return false;
  }

  if (appointment.phase === "cancelled") {
    return false;
  }

  if (!showId) {
    return false;
  }

  const appointmentType = appointment.type.value;
  return (appointmentType === "flight" ||
        appointmentType === "train" ||
        appointmentType === "groundTransport" ||
        appointmentType === "accommodation");
};